<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :key="modelName+'viewTitle'"
                           :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_vo="customVuexName + 'Vo'"
                                           :$_em-custom-vuex-mixin_filter="customVuexName + 'Filter'"
                                           :query-api="'findByFilter/' + customVuexName"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="entityResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :withCustomRowActions="isEndInspect"
                                      with-custom-row-actions-first-column
                                      ignoreMaxTableItemLimit
                                      custom-row-actions-text-first-column="操作"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      :$_em-custom-vuex-mixin_vo="customVuexName + 'Vo'"
                                      :$_em-custom-vuex-mixin_filter="customVuexName + 'Filter'"
                                      :query-api="'findByFilter/' + customVuexName"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button-group>
                                        <em-button
                                            type="search"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="保存"
                                            :disabled="$_notCheckedOne"
                                            :busy="statusChangeLoading"
                                            show-name
                                            @click="changeTaskResultStatus('saved')"
                                        ></em-button>
                                        <em-button
                                            type="search"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="释放"
                                            :disabled="$_notCheckedOne"
                                            :busy="statusChangeLoading"
                                            show-name
                                            confirm-text="确认释放该检验任务的检验结果吗？"
                                            @click="changeTaskResultStatus('finished')"
                                        ></em-button>
                                        <em-button
                                            type="search"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="拷贝"
                                            :disabled="!copyEnable"
                                            :busy="copyTemplateLoading"
                                            show-name
                                            @click="$refs.copyTemplate.showModal()"
                                        ></em-button>
                                        <em-button
                                            type="export"
                                            custom-icon="fa fa-fw fa-lg fa-download"
                                            :disabled="$_notChecked"
                                            custom-label="批量下载"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            @click="downloadAllWithParamName('taskAttachment')"
                                        ></em-button>
                                        <em-button v-if="isIncomingInspect"
                                                   class="btn btn-outline-primary btn-sm"
                                                   custom-label="扫码识别"
                                                   showName
                                                   type='search'
                                                   @click="openScannerDialog()"
                                        >
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #customRowActionsFirstColumn="{row}">
                                    <b-button-group>
                                        <em-button
                                            type="process"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="发起NCR"
                                            @click="openNCRDialog(row)"
                                        ></em-button>
                                        <em-button
                                            type="fillTemplate"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="填写模板"
                                            :busy="templateDataIsBusy"
                                            @click="openModelChoose(row)"
                                        ></em-button>
                                        <em-button
                                            type="qualified"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="检验合格"
                                            :busy="checkQualifiedIsBusy"
                                            @click="checkDialog(row)"
                                        ></em-button>
                                        <em-button
                                            type="uploadFile"
                                            class="btn btn-outline-primary btn-sm"
                                            custom-label="上传附件"
                                            @click="uploadAttachment(row)">
                                        </em-button>
                                        <em-button type="gotoChild"
                                                   v-if="row.sdrId"
                                                   custom-label="去SDR页面"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="gotoSdr(row)">
                                        </em-button>
                                        <em-button type="gotoChild"
                                                   v-if="row.packingMaterial"
                                                   custom-label="查看打包物料"
                                                   v-bind:class="'btn btn-outline-success btn-sm'"
                                                   @click="gotoPackingMaterial(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="gotoChild"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="gotoDeliveryMaterial(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

        <el-dialog title="发起NCR" :visible.sync="submitNCRDialogVisible" @close="closeNCRDialog">
            <el-input v-model="ncrDescription" placeholder="NCR描述" clearable></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="submitNCRDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitNCR" :loading="ncrLoading">确 定</el-button>
            </div>
        </el-dialog>

        <em-modal-normal-input-entity-selector ref="inspectTemplateEntitySelector"
                                               entity="sithMesQualityInspectTemplate"
                                               @entityModalSelectSelected="gotoInspectTemplate">
        </em-modal-normal-input-entity-selector>

        <el-dialog :visible.sync="checkQualifiedDialog" width="25%" @close="selectedRow = null">
            <div class="d-flex flex-row m-auto">
                <button type="button" class="btn btn-success large-btn" @click="checkQualified(true)">合格</button>
                <button class="btn btn-danger large-btn ml-2" type="button" @click="checkQualified(false)">不合格
                </button>
            </div>
        </el-dialog>

        <el-dialog :center="true" :close-on-click-modal='false' append-to-body :visible.sync="scannerVisible"
                   title="扫一扫" @close="closeScannerDialog">
            <qr-code-scanner ref="inspectScanner" @getCodeData='getIncomingTask'>
            </qr-code-scanner>
        </el-dialog>

        <ReBModal header="上传附件"
                  @ok="submitAttachmentChange"
                  @hide="hideAttachmentModal"
                  ref="uploadAttachment">
            <em-attachment get-items-by-self
                           class="w-100"
                           is-editing
                           :avoid-null="false"
                           @idsChanged="changeAttachmentIds"
                           :attachment-ids="selectedRow==null?'':selectedRow.taskAttachment">
            </em-attachment>
        </ReBModal>

        <ReBModal ref="copyTemplate"
                  @ok="copyFOTO"
                  header="拷贝检验项">
            <div class="d-flex flex-column" @click="switchSides">
                <h5>{{ copyTemplate.fromOne.code }}</h5>
                <div class="font-weight-bold">↓</div>
                <h5>{{ copyTemplate.toOne.code }}</h5>
            </div>
        </ReBModal>

        <ReBModal ref="modelChoose" header="偏好模式选择">
            <div class="d-flex flex-row m-auto">
                <button type="button" class="btn btn-success large-btn" @click="viewTemplate(false)">编辑模式</button>
                <button class="btn btn-warning large-btn ml-2" type="button" @click="viewTemplate(true)">查找模式
                </button>
            </div>
        </ReBModal>

        <ReBModal ref="miniTableModal" header="通用模板" @ok="submitBatchTemplate" large>
            <mini-table v-if="targetTemplateResultId"
                        ref="commonTemplateTable"
                        :fields="commonTemplateFields"
                        entity-name="sithMesQualityInspectCommonTemplate"
                        :filter-holder="{resultIdFilter: targetTemplateResultId}"
                        :save-holder="{resultId: targetTemplateResultId}">
            </mini-table>
        </ReBModal>
    </div>
</template>

<script>
import emCommonListMixin from "@/mixin/em/common/list";
import EmModalNormalInputEntitySelector from "@/components/em/EmModal/NormalInputEntitySelector";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import EmAttachment from "@/components/em/EmAttachment";
import EmCommonApi from "@/mixin/em/common/api";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory"

export default {
    name: "SithMesQualityInspectTaskList",
    components: {MiniTable, EmAttachment, ReBModal, EmModalNormalInputEntitySelector, qrCodeScanner},
    mixins: [emCommonListMixin, EmCommonApi, emCommonGotoMixin, emTableCheckedMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        },
        customVuexName: {
            type: String
        }
    },
    computed: {
        modelName() {
            return 'sithMesQualityInspectTask'
        },
        $_customVuexName() {
            return this.customVuexName;
        },
        tableRows() {
            return this.$refs.emTable.rows;
        },
        copyEnable() {
            return this.checkedItems && this.checkedItems.length === 2;
        },
        taskId() {
            return this.$route.query.id;
        }
    },
    data() {
        return {
            ncrDescription: null,
            submitNCRDialogVisible: false,
            selectedRow: null,
            ncrLoading: false,

            selectTaskId: null,
            templateDataIsBusy: false,

            checkQualifiedDialog: false,
            checkQualifiedIsBusy: false,

            attachmentIds: '',
            statusChangeLoading: false,

            copyTemplate: {
                fromOne: '',
                toOne: ''
            },
            copyTemplateLoading: false,

            preCustomVuexName: '',
            commonTemplateFields: [
                {key: 'position', label: '位置', isInput: true},
                {key: 'designValue', label: '设计值', isInput: true},
                {key: 'actualValue', label: '实测值', isInput: true},
                {key: 'equipNumber', label: '量具编号', isInput: true},
                {
                    key: 'qualified', label: '是否合格',
                    type: 'select',
                    options: [
                        {value: true, text: '是'},
                        {value: false, text: '否'}
                    ],
                    isInput: true
                },
                {key: 'remark', label: '备注', isInput: true},
            ],
            targetTemplateResultId: undefined,
            isEndInspect: false,
            isIncomingInspect: false,
            scannerVisible: false,
        }
    },
    watch: {
        customVuexName() {
            this.$nextTick(() => {
                this.initFilter(false);
                this.$refs.emListFilter.doQuery();
                this.$refs.viewTitle.getMenuTitleData();
                this.setCustomVuexName();
                this.setIsEndInspect();
                this.setIsIncomingInspect();
            });
        },
        checkedItems() {
            if (this.copyEnable) {
                this.copyTemplate.fromOne = this.checkedRows[0];
                this.copyTemplate.toOne = this.checkedRows[1];
            } else {
                this.copyTemplate = {
                    fromOne: '',
                    toOne: ''
                }
            }
        },
        taskId() {
            this.initFilter();
        }
    },
    mounted() {
        this.preCustomVuexName = this.customVuexName;
        this.initFilter();
        this.setCustomVuexName();
    },
    created() {
        this.setIsEndInspect();
        this.setIsIncomingInspect();
        this.$set(this.$route.params, 'enableDrawingQuery', true);
    },
    methods: {
        initFilter(tag) {
            if (this.taskId) {
                this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.taskId);
                if (tag !== false) {
                    if (this.preCustomVuexName === this.customVuexName) {
                        this.$refs.emListFilter.doQuery();
                    } else {
                        this.preCustomVuexName = this.customVuexName;
                    }
                }
            }
        },
        openNCRDialog(row) {
            console.log(row)
            this.selectedRow = row;
            this.submitNCRDialogVisible = true;
        },
        closeNCRDialog() {
            this.ncrDescription = null;
            this.selectedRow = null;
        },
        submitNCR() {
            if (this.ncrDescription == null || this.ncrDescription === '') {
                this.$message.warning("请输入NCR描述");
            } else {
                this.ncrLoading = true;
                let _api = process.env.VUE_APP_SITHMES_QUALITY_URL + '/sithMesNcrProcessTask';
                this.$_emApiMixin_put(_api, {
                    objectId: this.selectedRow.id,
                    objectType: this.selectedRow.inspectTypeId,
                    ncrDescription: this.ncrDescription
                }).then(response => {
                    console.log(response);
                    this.$message.success("发起成功");
                }).finally(() => {
                    this.submitNCRDialogVisible = false;
                    this.ncrLoading = false;
                });
            }
        },
        openTemplateModal(row) {
            this.selectTaskId = row.id;
            this.templateDataIsBusy = true;
            this.getTemplateDataOfTask();
        },
        gotoInspectTemplate(row) {
            if (row != null && row.id != null) {
                if (this.selectTaskId == null) {
                    this.$message.error("未知的taskId");
                } else {
                    this.$router.push("/sithMes/quality/sithMesQualityInspectTemplateSingleView?templateId=" + row.id + "&taskId=" + this.selectTaskId);
                }
            }
        },
        getTemplateDataOfTask() {
            let api = process.env.VUE_APP_SITHMES_QUALITY_URL + '/sithMesQualityInspectTemplateData/findByFilter';
            this.$_emApiMixin_post(api, {
                taskIdFilter: this.selectTaskId
            }).then((response) => {
                console.log(response);
                if (response.data.list.length > 0) {
                    let tempObject = {};
                    for (let item of response.data.list) {
                        if (item.value === undefined) {
                            item.value = '';
                        }
                        tempObject[item.templateId + '**' + item.seq] = item;
                    }
                    this.$router.push({
                        path: "/sithMes/quality/sithMesQualityInspectTemplateSingleView",
                        name: "SithMesQualityInspectTemplateSingleView",
                        params: {
                            templateData: tempObject
                        },
                        query: {
                            templateId: response.data.list[0].templateRootId,
                            taskId: this.selectTaskId
                        }
                    })
                } else {
                    this.$refs['inspectTemplateEntitySelector'].showModal();
                }
            }).finally(() => {
                this.templateDataIsBusy = false;
            })
        },
        checkDialog(row) {
            this.checkQualifiedDialog = true;
            this.selectedRow = row;
        },
        checkQualified(qualified) {
            this.checkQualifiedDialog = false;
            this.checkQualifiedIsBusy = true;
            let api = process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesQualityInspectTask/task/"
                + (qualified ? 'qualified' : 'unqualified')
                + "?taskId=" + this.selectedRow.id
                + "&qualified=" + qualified;
            this.$_emApiMixin_post(api).then(() => {
                this.$refs.emListFilter.doQuery();
            }).finally(() => {
                this.checkQualifiedIsBusy = false;
            });
        },
        uploadAttachment(row) {
            this.selectedRow = row;
            this.$refs.uploadAttachment.showModal();
        },
        submitAttachmentChange() {
            let api = process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesQualityInspectTask/selective";
            this.$_emApiMixin_put(api, {
                id: this.selectedRow.id,
                taskAttachment: this.attachmentIds
            }).then((response) => {
                console.log(response);
                this.$message.success("保存成功")
            })
        },
        hideAttachmentModal() {
            this.selectedRow = null;
            this.attachmentIds = '';
        },
        changeAttachmentIds(id) {
            this.attachmentIds = id;
        },
        setCustomVuexName() {
            this.$store.commit('commonList/setCustomVuexName', this.customVuexName);
        },
        changeTaskResultStatus(type) {
            this.statusChangeLoading = true;
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesQualityInspectTask/changeTaskResultStatus/" + type + "?inspectTaskId=" + this.selectIds
            }).then(() => {
                this.$message.success("操作成功");
            }).finally(() => this.statusChangeLoading = false);
        },
        openModelChoose(row) {
            this.selectedRow = row;
            this.$refs.modelChoose.showModal();
        },
        viewTemplate(needGoto) {
            this.templateDataIsBusy = true;
            this.$refs.modelChoose.changeLoading(true);
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesQualityInspectTask/createOrGetTemplate?inspectTaskId=" + this.selectedRow.id
            }).then(response => {
                if (response) {
                    if (needGoto) {
                        this.$store.dispatch('routeStore/addContent', {key: 'templateResultId', value: response});
                        this.$store.dispatch('routeStore/addContent', {
                            key: 'templateCustomVuexName',
                            value: this.customVuexName === 'process' ? 'withOperation' : 'withOut'
                        });
                        this.$_emGotoMixin_gotoHolderList('sithMesQualityInspectCommonTemplate', {}, {}, false, {});
                    } else {
                        this.targetTemplateResultId = response;
                        this.openMiniTableEdit();
                    }
                }
            }).finally(() => {
                this.templateDataIsBusy = false;
                this.$refs.modelChoose.changeLoading(false);
                this.$refs.modelChoose.hide();
            });
        },
        openMiniTableEdit() {
            this.$refs.miniTableModal.showModal();
        },
        submitBatchTemplate() {
            this.templateDataIsBusy = true;
            let columnEditData = this.$refs.commonTemplateTable.columnEditData();
            this.$store.dispatch('api/put', {
                url: process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesQualityInspectCommonTemplate/saveAllSelective",
                entity: columnEditData
            }).then(() => {
                this.$message.success("保存成功");
            }).finally(() => this.templateDataIsBusy = false);
            this.$refs.commonTemplateTable.doDeleteRows();
        },
        switchSides() {
            let temp = this.copyTemplate.toOne;
            this.copyTemplate.toOne = this.copyTemplate.fromOne;
            this.copyTemplate.fromOne = temp;
        },
        copyFOTO() {
            this.copyTemplateLoading = true;
            this.$store.dispatch('api/get', {
                url: `${process.env.VUE_APP_SITHMES_QUALITY_URL}/sithMesQualityInspectTask/copyItemsFOTO?fromId=${this.copyTemplate.fromOne.id}&toId=${this.copyTemplate.toOne.id}`
            }).then(() => {
                this.$message.success("操作成功");
            }).finally(() => this.copyTemplateLoading = false);
        },
        setIsEndInspect() {
            if (this.customVuexName === 'sithMesQualityInspectTaskEnd') {
                this.isEndInspect = true;
            } else {
                this.isEndInspect = false;
            }
        },
        setIsIncomingInspect() {
            if (this.customVuexName === 'sithMesQualityInspectTaskIncoming') {
                this.isIncomingInspect = true;
            } else {
                this.isIncomingInspect = false;
            }
        },
        gotoDeliveryMaterial(row) {
            this.$_emGotoMixin_gotoHolderList("sithMesInventoryDeliveryMaterial"
                , {deliveryTaskIdFilter: row.inspectObject}
                , {deliveryTaskId: row.inspectObject}, false, {})
        },
        openScannerDialog() {
            this.scannerVisible = true;
            setTimeout(() => {
                this.$refs.inspectScanner.openCamera('');
            }, 500);
        },
        getIncomingTask(data) {
            console.log("get qr code data:" + data);
            this.scannerVisible = false;
            let self = this;
            //检验二维码的数据格式
            try {
                var obj = JSON.parse(data);
                var poNumber = obj.PO;
                var item = obj.PoItem;
                var materialCode = obj['物料号'];
                console.log(poNumber);
                console.log(item);
                console.log(materialCode);
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('poNumberFilter', poNumber);
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('itemCodeFilter', item);
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('materialCodeFilter', materialCode);
            this.$refs.emListFilter.doQuery();
        },
        closeScannerDialog() {
            this.$refs.inspectScanner.closeCamera();
            this.$refs.inspectScanner.resetOutputData();
            this.scannerVisible = false;
        },
        gotoSdr(row) {
            this.$_emGotoMixin_gotoHolderList(
                "sithMesStoolPoSdr",
                {poNumberFilter: row.poNumber, itemNumberFilter: row.itemCode},
                {poNumber: row.poNumber, itemNumber: row.itemCode},
                false,
                {pathType: "list"},
                undefined,
                undefined,
                undefined,
                "sithMesStoolPoSdrEngineerList"
            );
        },
        gotoPackingMaterial(row) {
            this.$_emGotoMixin_gotoHolderList("sithMesInventoryPackingBom"
                , {purchaseNumberFilter: row.poNumber, itemCodeFilter: row.itemCode}
                , {}, true, {})
        },
    }
};
</script>

<style scoped>
.large-btn {
    width: 50%;
    height: 7rem;
    border-radius: 1rem;
}
</style>
